import { ColorBlock } from "@/components/page";
import { useResourceList } from "@/components/data";

type MunicipalityTask = {
  id: number;
  task_num: number | null;
  title: string;
  status: string | null;
  details: string | null;
  sort_order: number;
};

const STATUS_DOT: Record<string, string> = {
  ממתין: "bg-amber-400",
  לקביעה: "bg-sky-400",
  בתהליך: "bg-violet-400",
  הושלם: "bg-emerald-400",
};

export function PaamonMunicipalityPage() {
  const { data, isLoading } = useResourceList<MunicipalityTask>("paamon_municipality_tasks");
  const items = data ?? [];

  return (
    <div className="space-y-6 sm:space-y-7">
        <header className="pb-2">
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-stone-500">
            עיריית תל אביב-יפו · האגף לחינוך מיוחד
          </p>
          <h1 className="mt-3 flex items-baseline gap-3 text-2xl sm:text-3xl font-bold tracking-tight text-stone-900">
            <span className="tabular-nums" dir="ltr">{items.length}</span>
            <span className="text-stone-300 text-lg sm:text-xl">·</span>
            <span className="text-stone-700 text-lg sm:text-xl">משימות</span>
          </h1>
          <p className="mt-3 max-w-xl text-sm sm:text-base text-stone-600 leading-snug">
            מעקב אורית חפץ — חוזים, פגישות, אישורים.
          </p>
        </header>

        {isLoading ? (
          <p className="text-sm text-stone-500">טוען…</p>
        ) : items.length === 0 ? (
          <ColorBlock tint="sage" className="text-center" size="lg">
            <p className="text-base sm:text-lg font-bold tracking-tight text-stone-900">אין משימות פתוחות.</p>
          </ColorBlock>
        ) : (
          <div className="space-y-3">
            {items.map((t) => {
              const dot = (t.status && STATUS_DOT[t.status]) ?? "bg-stone-400";
              return (
                <div key={t.id} className="rounded-2xl bg-white px-6 py-5">
                  <div className="flex items-start justify-between gap-4">
                    <div className="flex items-start gap-4 flex-1 min-w-0">
                      {t.task_num != null && (
                        <span className="flex shrink-0 items-center justify-center h-8 w-8 rounded-full bg-stone-900 text-stone-50 text-sm font-bold tabular-nums" dir="ltr">
                          {t.task_num}
                        </span>
                      )}
                      <div className="flex-1 min-w-0">
                        <h2 className="text-base sm:text-lg font-semibold tracking-tight text-stone-900 leading-snug">
                          {t.title}
                        </h2>
                        {t.details && (
                          <p className="mt-2 text-sm text-stone-600 leading-relaxed">{t.details}</p>
                        )}
                      </div>
                    </div>
                    {t.status && (
                      <span className="shrink-0 inline-flex items-center gap-2 text-sm text-stone-700">
                        <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
                        {t.status}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
  );
}
